<template>
    <div class="card mb-0 shadow">
        <div class="card-body">
            <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                    <h4>Fortalecimento de Vínculo Familiares</h4>
                </div>
            </div>
            <load mode="table" v-if="loading" />
            <form v-else @submit.prevent="cadastrarVinculo">
                <div class="row">
                    <form-input
                        grid="6"
                        v-model="sente_familia"
                        label="Como o idoso se sente em relação a família?"
                    />
                    <form-select
                        grid="6"
                        :itens="$root.arrays.idoso_vinculo_acompanhamento_acao"
                        v-model="acao"
                        label="Ação"
                    />
                </div>
                <div
                    class="row col-12 pb-3 px-0 m-0 d-flex justify-content-end"
                >
                    <button
                        class="btn btn-primary m-0"
                        data-style="zoom-in"
                        type="submit"
                    >
                        Cadastrar
                    </button>
                </div>
            </form>
            <div class="row">
                <div class="col-12" v-if="VinculoFamiliar.length > 0">
                    <table class="table table-sm border">
                        <tbody>
                            <tr
                                v-for="vinculo in VinculoFamiliar"
                                :key="vinculo.id"
                            >
                                <td>
                                    {{ vinculo.sente_familia }}
                                </td>
                                <td>
                                    {{
                                        verificarValueArray(
                                            vinculo.acao,
                                            $root.arrays
                                                .idoso_vinculo_acompanhamento_acao
                                        )
                                    }}
                                </td>
                                <td>
                                    <button
                                        title="Excluir"
                                        @click="
                                            excluirVinculo(vinculo.id, index)
                                        "
                                        class="float-right btn px-2 mb-0 btn-danger btn-xs"
                                    >
                                        <i class="mdi mdi-close"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12" v-else>
                    <h4 class="text-secondary">
                        <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
                        Nada salvo aqui.
                    </h4>
                </div>
                <div class="col-12">
                    <div class="row">
                        <form-input
                            v-model="item.pessoas_vinculo"
                            label="Quais pessoas tem um vínculo com idoso, inclusive visitam-o regularmente?"
                        />
                        <form-textarea-editor
                            label="Percepção da Equipe SUAS quanto às relações afetivas"
                            :required="true"
                            v-model="item.vinculo_familiar_percepcao"
                        />
                    </div>
                    <div
                        class="row col-12 pb-3 px-0 m-0 d-flex justify-content-end"
                    >
                        <button
                            class="btn btn-success m-0 btn-submit"
                            @click="submit"
                        >
                            Salvar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            pessoas_vinculo: "",
            sente_familia: "",
            acao: "",
            violencia_percepcao: "",
            loading: false,
            VinculoFamiliar: {},
        };
    },
    watch: {
        item() {
            if (this.item.VinculoFamiliar != null) {
                this.VinculoFamiliar = this.item.VinculoFamiliar;
            }
        },
    },
    mounted() {
        if (this.item.VinculoFamiliar != null) {
            this.VinculoFamiliar = this.item.VinculoFamiliar;
        }
    },
    methods: {
        submit() {
            this.item.VinculoFamiliar = this.VinculoFamiliar;
            this.$emit("submit");
        },
        cadastrarVinculo() {
            this.loading = true;

            axios
                .post(
                    `api/dashboard/acolhimento/idoso/vinculo/store`,
                    {
                        sente_familia: this.sente_familia,
                        acao: this.acao,
                        acolhimento_id: this.item.id,
                    },
                    {
                        header: { "Content-Type": "multipart/form-data" },
                        onUploadProgress: (event) => {
                            let progress = Math.round(
                                (event.loaded * 100) / event.total
                            );
                            this.progressCompleted = progress;
                        },
                    }
                )
                .then((response) => {
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                    this.$emit("reload");
                })
                .finally(() => {
                    this.sente_familia = "";
                    this.acao = "";
                    this.loading = false;
                });
        },
        excluirVinculo(id) {
            swal.fire({
                text: "Aguarde a ação ser finalizada.",
                icon: "warning",
                showConfirmButton: false,
                timer: 1500,
            });
            axios
                .get(`api/dashboard/acolhimento/idoso/vinculo/excluir/${id}`)
                .then((response) => {
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                    this.$emit("reload");
                });
        },
        verificarValueArray(value, array, valueIsArray = false) {
            if (valueIsArray && value) {
                var a = "";
                for (var i = 0; i < value.length; i++) {
                    const result = array.filter((item) => item.id == value[i]);
                    a += result[0].value + (i < value.length - 1 ? "," : "");
                }

                return a;
            } else {
                const result = array.filter((item) => item.id == value);
                return result[0] ? result[0].value : "";
            }
        },
    },
};
</script>
